export default "__VITE_ASSET__CFAi7BM___"